export default __webpack_public_path__ + "resources/icons/n432-1cb5.png";